import { NgModule } from '@angular/core';
import type { Routes } from '@angular/router';
import { RouterModule } from '@angular/router';
import { BlogPageDataResolver } from '@core-mkt/resolvers/page-data/blog-page-data.resolver';
import { PageDataResolver } from '@core-mkt/resolvers/page-data/page-data.resolver';
import { PreviewBrokenComponent } from '@core-mkt/shared/components/preview-broken/preview-broken.component';
import { ReadyzComponent } from '@core-mkt/shared/components/readyz/readyz.component';
import { PageNotFoundComponent } from './templates/page-not-found/page-not-found.component';
import { TemplateDynamicComponent } from './templates/template-dynamic/template-component/template-dynamic.component';

let appRoutes: Routes = [];

// Common routes for all brands
appRoutes = appRoutes.concat(
  {
    // Exception for homepage since its slug and path cannot line up.
    path: '',
    children: [
      {
        path: '',
        resolve: { pageData: PageDataResolver },
        pathMatch: 'full',
        component: TemplateDynamicComponent,
      },
    ],
  },
  {
    path: 'preview/',
    resolve: { pageData: PageDataResolver },
    children: [
      {
        path: '',
        pathMatch: 'full',
        component: TemplateDynamicComponent,
      },
    ],
  },
  {
    path: 'preview-broken/',
    component: PreviewBrokenComponent,
  },
  {
    path: '404/',
    component: PageNotFoundComponent,
  },
  {
    // Deep readiness probe for ALB/k8s: exercises the full Angular SSR
    // pipeline (bootstrap + router + component render) to verify the app
    // bundle itself is healthy. Resolver-less so no Craft GraphQL call
    // is made. For a shallow Node-only liveness probe, see /livez wired
    // at the Express layer in server.ts.
    path: 'readyz/',
    component: ReadyzComponent,
  },
);

appRoutes = appRoutes.concat(
  {
    path: 'blog',
    data: { isBlog: true },
    children: [
      {
        path: '**',
        resolve: { pageData: PageDataResolver },
        component: TemplateDynamicComponent,
      },
    ],
  },
  {
    path: 'trending',
    data: { isBlog: true },
    children: [
      {
        path: '**',
        resolve: { pageData: PageDataResolver },
        component: TemplateDynamicComponent,
      },
    ],
  },
  {
    path: 'resources',
    data: { isBlog: true },
    children: [
      {
        path: '**',
        resolve: { pageData: PageDataResolver },
        component: TemplateDynamicComponent,
      },
    ],
  },
  {
    path: 'defensive-driving/trending',
    data: { isBlog: true },
    children: [
      {
        path: '**',
        resolve: { pageData: PageDataResolver },
        component: TemplateDynamicComponent,
      },
    ],
  },
);

// Catch-all route (must be last)
appRoutes.push({
  path: '**',
  resolve: { pageData: PageDataResolver },
  component: TemplateDynamicComponent,
});

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {
      initialNavigation: 'enabledBlocking',
    }),
  ],
  exports: [RouterModule],
  providers: [PageDataResolver, BlogPageDataResolver],
})
export class AppRoutingModule {}
